import chevronLeft from './chevron-left.svg';
import chevronRight from './chevron-right.svg';

export const statsIcons = {
    chevronLeft,
    chevronRight
};